import "virtual:windi-base.css"
import "virtual:windi-components.css"
import "@/styles/components.scss"
import "virtual:windi-utilities.css"
import "virtual:windi-devtools"

import App from "@/App.vue"
import router from "./router"
import { createHead } from "@unhead/vue"
// import * as Sentry from "@sentry/vue"
// import { Integrations as SentryIntegrations } from "@sentry/tracing"

import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "@/queryClient"
import { Chart as ChartJS } from "chart.js"

const app = createApp(App)

app.use(VueQueryPlugin, { queryClient })

app.use(router)
const head = createHead()
app.use(head)
app.mount("#app")

ChartJS.defaults.font.family = window
  .getComputedStyle(document.documentElement)
  .getPropertyValue("font-family")

export default app
